<!--
    描述:
    日期: 2020.2.16
    created by lff
-->
<template>
  <div>
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
      <FormItem label="手机号" prop="mobilePhone">
        <Input v-model="formCustom.mobilePhone" placeholder="请输入手机号"></Input>
      </FormItem>
      <!--<FormItem label="手机验证码">
        <Input v-model="formCustom.code" search enter-button="获取验证码" placeholder="请输入手机号验证码" @on-search="getCode"></Input>
      </FormItem>-->
      <FormItem label="姓名" prop="sname">
        <Input type="text" v-model="formCustom.sname" placeholder="请输入姓名"></Input>
      </FormItem>
      <FormItem label="单位" prop="company">
        <Input type="text" v-model="formCustom.company" placeholder="请输入单位"></Input>
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model="formCustom.email" placeholder="请输入邮箱"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formCustom')" class="ml140">马上体验</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
  import {applyAccount} from '../../api/joinUs'
  export default {
    name: 'join-us',
    components: {},
    props: {},
    data() {
      //号码验证
      const checkNum = (rule, value, callback) => {
        if (value && isNaN(value)) {
          /*this.$Message.warning('手机请输入数字')
          this.formCustom.mobilePhone = ''*/
          callback(new Error('手机请输入数字'));
        } else if (!/^1(3|4|5|7|8)\d{9}$/.test(value)) {
          // this.$Message.warning('请正确输入号码')
          callback(new Error('请正确输入号码'));
        } else {
          callback();
        }
      };
      return {
        formCustom: {
          mobilePhone: '',
          code: '',
          sname: '',
          company: '',
          email: ''
        },
        ruleCustom: {
          mobilePhone: [
            {required: true, validator: checkNum, trigger: 'blur'}
          ],
          sname: [{required: true, message: "不能为空", trigger: 'blur'}],
          company: [{required: true, message: "不能为空", trigger: "blur"}],
          email: [
            { required: true, message: '不能为空', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
          ],
        }
      };
    },
    created() {
    },
    mounted() {
    },
    methods: {
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            applyAccount(this.formCustom).then(res => {
              if (+res.code === 0) {
                this.$Message.success('体验成功!');
                this.$emit('on-success')
              }else {
                this.$Message.error(res.msg);
              }
            })
          } else {
            this.$Message.error('提交失败!');
          }
        })
      },
      getCode(value){
        // console.log(value);
      },
    },
    filters: {},
    computed: {},
    watch: {}
  }

</script>

<style scoped>
  .ml140 {
    margin-left: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/bm-project/joinUs.vue